module.exports = __webpack_public_path__ + "img/sign-out.87157d08.svg";